import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools }          from 'redux-devtools-extension';
import thunkMiddleware                  from 'redux-thunk';

import { Reducer } from '../reducers';

export const Store = createStore(Reducer, {}, composeWithDevTools(applyMiddleware(thunkMiddleware)));
